import { Price } from "flicket-ui";

interface PriceProps {
  price: number;
  currency: string;
}

export default function PriceOrFree({ price, currency }: PriceProps) {
  if (price === 0) {
    return <>Free</>;
  }

  return <Price price={price} currency={currency} />;
}
